import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { WidgetSettingsControlBase } from '../control-base';

@Component({
    selector: 'widget-settings-control-form-listing',
    template: `
        <div class="EditWidgetContentPadding widget-settings-block-padding widget-list-settings">
            <div class="widget-settings-group-header">{{ 'widget_settings_options_title' | fiAppText }}</div>

            <div class="widget-settings-checkbox-list">
                <mat-checkbox [(ngModel)]="Settings.DisplayContainer" (ngModelChange)="settingsOnChange()">
                    {{ 'widget.display_container' | fiAppText }}
                </mat-checkbox>

                <mat-checkbox [(ngModel)]="Settings.DisplayHeader" (ngModelChange)="settingsOnChange()">
                    {{ 'widget.display_header' | fiAppText }}
                </mat-checkbox>

                <mat-checkbox [(ngModel)]="Settings.ShowInApp" (ngModelChange)="settingsOnChange()">
                    {{ 'widget_settings.show_in_app' | fiAppText }}
                </mat-checkbox>

                <mat-checkbox [(ngModel)]="Settings.ShowDescription" (ngModelChange)="settingsOnChange()">
                    {{ 'widget_settings_show_description' | fiAppText }}
                </mat-checkbox>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'widget-settings-control-form-listing' },
    standalone: false,
})
export class WidgetSettingsControlFormListingComponent extends WidgetSettingsControlBase {}
